module.exports = __webpack_public_path__ + "static/5-Mini-Theatre-0d9f830642278abe9bed671672f1954c.jpg";